import types from '../types'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import {getModules} from './getModules'
import {getTools} from './getTools'
import {getSummaries} from './getSummaries'
import {getEditPrompts} from './getEditPrompts'

export const onSignInSuccess = (user, database) => (dispatch) => {
  if (user && user.uid) {
    dispatch(getModules(database))
    dispatch(getTools(database))
    dispatch(getSummaries(database))
    dispatch(getEditPrompts(database))
    const isCodeBreakUser = [
      'XX5CFjONUcNwtRqVKs37bbEjkvg2', // Declan
      'HDE7m0uCWfW4Hbsy0zKbc28A0Ju2', // Eric
      'KRdZMN8atEW3YcLoxn7OSRw8lOl2', // Brent
      'EnX8Gk0D8mOpcqIYDx200y7WqK23', // Alex
      '5P9HuPmKRff2UozP5kiWjhRgiDn2', // Keith
      'YULOEoOTXRYbZFIi6ycqULSrhcz1', // Dylan
    ].includes(user.uid)
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isFirebaseSignedIn: true,
        isMFANeeded: false,
        isCodeBreakUser: isCodeBreakUser,
        user: user,
        isSignedIn: true, // To have demo select - comment this out
      }})
  }
}
